import { Skeleton } from "@/core/components/ui/skeleton";

export const LoadingTable = ({
  numberOfColumns,
}: {
  numberOfColumns: number;
}) => {
  return (
    <>
      {[...Array(8)].map((_, id) => {
        return (
          <tr key={id}>
            {[...Array(numberOfColumns)].map((_, _id) => (
              <td key={_id} className="px-6 pb-4 align-top">
                <Skeleton className="h-4 min-w-[16px] flex items-center mt-4 space-x-3" />
              </td>
            ))}
          </tr>
        );
      })}
    </>
  );
};
